<template>
  <a href="#" class="card">
    <img src="/images/temp/promo_bg.png" class="card-img" alt="">
    <div class="card-img-overlay">
      <div>
        <p class="card-text">
          Lorem ipsum
        </p>
        <div class="btn btn-outline-warning link">Zobacz więcej</div>
      </div>
    </div>
  </a>
</template>
<script>

export default {
  name: 'offer-empty',

  components: {},
  data() {
    return {}
  }
}
</script>>